/* Canonical v2 acquisition source. No financial authority and no consent inference. */
(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory(require('./nikuya-cart-runtime-authority.js'));else root.NikuyaCartProductionContext=factory(root.NikuyaCartRuntimeAuthority)})(globalThis,function(Authority){
 'use strict';
 const ttl=604800000,purchaserTtl=31536000000,storeKey='nikuya',stages={c1:'C1',c2:'C2',c3:'C3',c4:'C4'};
 const revisions={};for(const [id,selectors,profile] of [['nikuya_hero10_20260916',['c1','c2','c3'],'HERO_10'],['nikuya_hero15_20260916',['c4'],'HERO_15']])revisions[id]=Object.freeze({id,family:'NEW_CUSTOMER_HERO',percentageProfile:profile,stages:selectors.map(s=>stages[s]),pdpProfiles:Object.fromEntries(selectors.map(s=>[stages[s],stages[s]+'_NOTICE'])),cartProfile:'ACQUISITION_COMMON',ttlMs:ttl,status:'ACTIVE',issuedFrom:0,issuedUntil:null,honorUntil:null});
 const registry=Object.freeze({store:storeKey,revisions:Object.freeze(revisions)});
 function selector(url,origin){try{const u=new URL(url),v=u.searchParams.getAll('nky_acq');return u.origin===origin&&v.length===1&&Object.hasOwn(stages,v[0])?v[0]:null}catch(_){return null}}
 function create({url,origin,store,locks,canPersist=()=>false,clock=Date.now,navigationType='navigate'}={}){
  const key='nikuya:acquisition:v2',purchaserKey='nikuya:purchaser:v1',expiredKey=key+':expired';
  const selected=navigationType==='navigate'?selector(url,origin):null,capturedAt=clock();
  const candidate=selected&&Number.isSafeInteger(capturedAt)&&capturedAt>=0?Object.freeze({v:2,store:storeKey,family:'NEW_CUSTOMER_HERO',publicSelector:selected,stage:stages[selected],revision:selected==='c4'?'nikuya_hero15_20260916':'nikuya_hero10_20260916',capturedAt,expiresAt:capturedAt+ttl}):null;
  let page=candidate,durableObserved=false,entryConsumed=false;
  const permitted=()=>{try{return canPersist()===true}catch(_){return false}};
  async function resolve(){
   const now=clock();if(!Number.isSafeInteger(now)||now<0)return {active:false};
   if(permitted()&&store?.shared===true&&locks?.request){
    try{await locks.request(key+':'+origin,{mode:'exclusive'},async()=>{
     if(!permitted())throw Error('PERSISTENCE_DENIED');
     const saved=await store.get(key);
     if(saved!=null){
      durableObserved=true;page=saved;
      // A new explicit selector changes the active offer, never its original lifetime.
      // Consume once per document so older tabs cannot reassert their URL on refresh.
      if(!entryConsumed){
       entryConsumed=true;
       const selectedAt=saved.selectedAt??saved.capturedAt;
       const valid=await Authority.createAcquisitionAuthorityProvider({readResolvedContext:async()=>({active:now<saved.expiresAt,record:saved}),registry,readSuppression:async()=> 'NO_OVERRIDE',clock}).read();
       if(candidate&&valid.status==='VERIFIED_CONTEXT'&&Number.isSafeInteger(selectedAt)&&selectedAt>=saved.capturedAt&&selectedAt<=now&&candidate.capturedAt>selectedAt&&now<candidate.expiresAt){
        const replacement={...saved,publicSelector:candidate.publicSelector,stage:candidate.stage,revision:candidate.revision,selectedAt:candidate.capturedAt};
        if(!permitted())throw Error('PERSISTENCE_DENIED');
        await store.set(key,replacement);
        const verified=await store.get(key);
        if(JSON.stringify(verified)!==JSON.stringify(replacement))throw Error('SELECTION_NOT_DURABLE');
        page=verified;
       }
      }
      if(Number.isSafeInteger(saved.expiresAt)&&now>=saved.expiresAt){
       // Keep only a non-authorizing replay tombstone, never the expired acquisition record.
       if(store.retentionManaged!==true){await store.set(expiredKey,{v:1,expired:true});await store.set(key,null);}
      }
      return;
     }
     if(await store.get(expiredKey)!=null){durableObserved=true;page=null;return}
     if(durableObserved){page=null;return}
     if(!candidate||now>=candidate.expiresAt){page=candidate;return}
     if(!permitted())throw Error('PERSISTENCE_DENIED');
     await store.set(key,structuredClone(candidate));
     const verified=await store.get(key);
     if(JSON.stringify(verified)!==JSON.stringify(candidate))throw Error('CAPTURE_NOT_DURABLE');
     durableObserved=true;entryConsumed=true;page=verified;
    })}catch(_){return {active:false}}
   }
   if(!page||JSON.stringify(page).length>1024)return {active:false};
   return {active:now<page.expiresAt,record:structuredClone(page)};
  }
  async function suppression(){
   if(!permitted()||!store)return 'NO_OVERRIDE';
   try{const r=await store.get(purchaserKey),now=clock();return r?.v===1&&r.store===storeKey&&Number.isSafeInteger(r.purchasedAt)&&r.purchasedAt<=now&&r.expiresAt===r.purchasedAt+purchaserTtl&&now<r.expiresAt?'SUPPRESS':'NO_OVERRIDE'}catch(_){return 'NO_OVERRIDE'}
  }
  const authority=Authority.createAcquisitionAuthorityProvider({readResolvedContext:resolve,registry,readSuppression:suppression,clock});
  async function prepurchase(hero){
   const acquisition=await authority.read();
   if(acquisition.status!=='VERIFIED_CONTEXT'||Authority.mappingFor(hero).kind!=='hero')return null;
   return {...acquisition,status:'VALID',safeToPresent:true,heroEligible:true};
  }
  return Object.freeze({read:authority.read,prepurchase,resolve,suppression,key,purchaserKey,registry});
 }
 return Object.freeze({create,selector,registry,ttl,purchaserTtl});
});
